// extracted by mini-css-extract-plugin
export default {"container":"ProgramDataConfiguration_container__Ar+Rr"};